export default __webpack_public_path__ + "static/media/ico_checkbox_false.6ef6c763.svg";